import { fetchMediaAuthorArticlesPage } from '../api/media-authors.requests';
import {
  getMediaAuthorPageSSR,
  getMediaAuthorsCatalogSSR,
  getMediaAuthorsIndexableSSR,
  getMediaAuthorBySlugSSR,
} from '../api/media-authors.requests.ssr';

export {
  getMediaAuthorBySlugSSR as getMediaAuthorBySlug,
  getMediaAuthorsCatalogSSR as getMediaAuthorsCatalog,
  getMediaAuthorsIndexableSSR as getMediaAuthorsIndexable,
};

type GetMediaAuthorPageInput = {
  readonly username?: string;
  readonly slug?: string;
  readonly page?: number;
  readonly limit?: number;
};

export async function getMediaAuthorPage(input: GetMediaAuthorPageInput) {
  const username = input.username ?? input.slug;
  if (!username) {
    throw new Error('username or slug is required');
  }
  return getMediaAuthorPageSSR(username, input.page ?? 1, input.limit);
}

type GetMediaAuthorArticlesInput = {
  readonly slug?: string;
  readonly username?: string;
  readonly page?: number;
  readonly limit?: number;
};

/**
 * Paginates published articles for an author (client-side infinite scroll).
 */
export async function getMediaAuthorArticles(input: GetMediaAuthorArticlesInput) {
  const username = input.username ?? input.slug;
  if (!username) {
    throw new Error('username or slug is required');
  }
  return fetchMediaAuthorArticlesPage({
    username,
    page: input.page ?? 1,
    limit: input.limit,
  });
}
